export default "__VITE_ASSET__d89a7e78__"